import { Reveal, Overline } from "@/components/Reveal";
import { CallButton, WhatsAppButton } from "@/components/ContactButtons";
import { PHONE_DISPLAY } from "@/constants/site";

export default function CtaBanner() {
  return (
    <section data-testid="cta-banner" className="bg-[#161514] py-24 sm:py-28">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <Overline light>Preventivo Gratuito</Overline>
          <h2 className="mt-4 font-serif text-3xl font-semibold tracking-tight text-[#FAF8F5] sm:text-4xl">
            La tua casa merita mani esperte.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-[#FAF8F5]/65 md:text-lg">
            Chiamaci al {PHONE_DISPLAY} o scrivici su WhatsApp: fissiamo il
            sopralluogo gratuito entro 48 ore.
          </p>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <CallButton testid="cta-call-button" light />
            <WhatsAppButton testid="cta-whatsapp-button" light />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
